import { SalesStats } from 'src/app/models/core/chart-interfaces';
import { SalesSplitRow } from 'src/app/shared/components/sales-split-card/sales-split-card.component';
import { AmountInput, formatAmount, MISSING_AMOUNT_PLACEHOLDER } from 'src/app/utils/currency-format';
import { buildChannelSplitRows, ChannelAmounts } from './channel-split';
import { AttendanceKpis } from './event-kpis.mapper';
import { buildMetricStats, MetricStat } from './metric-stats';

/** Lo que muestra `app-report-kpi-block`: total, reparto por canal y métricas. */
export interface KpiBlockVm {
  readonly totalLabelKey: string;
  readonly totalDisplay: string;
  readonly splitRows: readonly SalesSplitRow[];
  readonly stats: readonly MetricStat[];
}

/** Bloque de ventas (Jefe/Admin y Vendedor): "Total vendido" con su reparto por canal. */
export function buildSalesKpiBlock(
  stats: readonly SalesStats[],
  totalAmount: AmountInput,
  amounts: ChannelAmounts,
): KpiBlockVm {
  return {
    totalLabelKey: 'reports-single-event.total-title',
    totalDisplay: formatAmount(totalAmount),
    splitRows: buildChannelSplitRows(amounts),
    stats: buildMetricStats(stats),
  };
}

/** Lo que necesita el bloque de asistencia; `totalTickets: null` = no se pudo cargar. */
export type AttendanceKpiBlockInput = Omit<AttendanceKpis, 'totalTickets'> & {
  readonly totalTickets: number | null;
};

/** Bloque de asistencia (Recepcionista/Scanner): cantidad de QRs, sin canales ni navegación. */
export function buildAttendanceKpiBlock(kpis: AttendanceKpiBlockInput): KpiBlockVm {
  return {
    totalLabelKey: 'reports-single-event.total-qr-title',
    totalDisplay: kpis.totalTickets === null ? MISSING_AMOUNT_PLACEHOLDER : String(kpis.totalTickets),
    splitRows: [],
    stats: buildMetricStats(kpis.stats),
  };
}
